import { connect, useSelector } from 'react-redux'
import React, { useState } from 'react'
import { getModel } from 'react-redux-form'
import { jt, t } from 'ttag'

import {
  loadSubsequentWipResults,
  loadWipResults
} from '../../../actions/assessments/workImportanceProfiler'
import { useTitleChange } from '../../../util/hooks'
import SearchQueryHandlerComponent from '../../../components/search/SearchQueryHandlerComponent'

const WorkImportanceProfilerResults = props => {
  const pageTitle = t`Work Importance Profiler Results`

  useTitleChange(pageTitle)

  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadWipResults
  const loadMoreFunction = loadSubsequentWipResults(filterModel)
  const searchRequest = useSelector(
    state => state.assessments.workImportanceProfiler.results
  )
  const strongLink = (
    <span className="occupation-link strong-match">{t`this color and marked with an *`}</span>
  )

  return [
    <div className="container" key="instructions">
      <p>
        {jt`Your work importance profile returned the following occupations. Occupations in ${strongLink} represent stronger matches. 
           You can compare up to four occupations by selecting the boxes to the left of the desired occupations and then clicking 
           on the Compare Selected button at the bottom of the page. You can also filter occupation lists by Job Zone (preparation required),
            salary, and more to help you refine your search.`}
      </p>
    </div>,
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      key="wip-results"
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      searchRequest={searchRequest}
      {...props}
    />
  ]
}

export default WorkImportanceProfilerResults
